const ROOT_QUERY_KEY = "categories" as const;

export const queryKeys = {
  // ...queryKeysFactory<
  //   //
  //   typeof ROOT_QUERY_KEY
  // >(ROOT_QUERY_KEY),

  productCounts: () => [ROOT_QUERY_KEY, "product-counts"] as const,

  /** Categories for a specific set of products (used by the cart's filter rail). */
  forProducts: (productIds: string[]) =>
    [ROOT_QUERY_KEY, "for-products", productIds] as const
};
